<template>
  <tr :class="['label-inp', label_inp_mid]">
    <td :class="['flex', 'style-l', type_title]">
      <div class="font-bold text-epip">{{title}}</div>
    </td>
    <td :title="content" :class="['data','flex', 'items-center', '', 'py-0', type_content]">
      <div class="text-epip">{{content}}</div>
    </td>
  </tr>
</template>

<script>
export default {
  name: 'Input',
  props: ['title', 'content', 'type_title', 'type_content', 'label_inp_mid']
}
</script>

<style lang="scss" scoped>
@import "./styles.scss";
.text-epip {
  @media only screen and (min-width: 768px){
    display: -webkit-box;
    -webkit-line-clamp: 2;
    -webkit-box-orient: vertical;
    overflow: hidden;
    text-overflow: ellipsis;
  }
  
}
</style>